import { PRESUPUESTADOR_SET_IS_RESERVATION } from '../constants'

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_IS_RESERVATION) {
        return {
            ...state,
            is_reservation: action.data
        }
    } else {
        return state
    }
}